(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-reviews-questions"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.bv-tab-btn');
  const panels = document.querySelectorAll('.bv-tab-panel');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      buttons.forEach(b => b.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));

      btn.classList.add('active');
      const target = btn.getAttribute('data-target');
      document.getElementById(target).classList.add('active');
    });
  });
  
  function findLabels() {
    const labels = document.querySelectorAll(
      ".bv-tab-panel .primary-rating-star-container span:first-child"
    );

    if (labels.length) {
      setTimeout(() => {
        labels.forEach((label, index) => {
          if (label.textContent.includes("star")) {
            console.log(label)
            label.textContent = label.textContent.replace(/star/gi, "Teapot");
          }
        });
      }, 200);

      observer.disconnect();
    }
  }

  const observer = new MutationObserver(() => {
    findLabels();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  findLabels();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corporate-gifting-guide"] && !Shopify.designMode) return;
  try {
    
  class GiftGuide extends HTMLElement {
    connectedCallback() {
      this.filterButtons = Array.from(this.querySelectorAll('.cgg-filter'));
      this.cards = Array.from(this.querySelectorAll('.cgg-card'));

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button));
      });

      this.initCounters();
    }

    applyFilter(activeButton) {
      const filter = activeButton.dataset.filter;

      this.filterButtons.forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive);
      });

      this.cards.forEach((card) => {
        const categories = (card.dataset.categories || '').split(' ').filter(Boolean);
        const matches = filter === 'all' || categories.includes(filter);
        card.classList.toggle('cgg-card--hidden', !matches);
      });
    }

    initCounters() {
      const values = Array.from(this.querySelectorAll('.cgg-stat__value'));
      if (!values.length) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const animateValue = (el) => {
        const target = el.dataset.value || '';
        const numberMatch = target.match(/\d+/);

        if (!numberMatch || reduceMotion) {
          el.textContent = target;
          return;
        }

        const endNumber = parseInt(numberMatch[0], 10);
        const suffix = target.slice(numberMatch.index + numberMatch[0].length);
        const duration = 1100;
        const startTime = performance.now();

        const step = (now) => {
          const progress = Math.min((now - startTime) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.floor(eased * endNumber) + suffix;
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            el.textContent = target;
          }
        };

        requestAnimationFrame(step);
      };

      if (!('IntersectionObserver' in window)) {
        values.forEach(animateValue);
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateValue(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );

      values.forEach((value) => observer.observe(value));
    }
  }

  customElements.define('gift-guide', GiftGuide);

  // "Order Form" links scroll manually instead of relying on the
  // browser's default anchor-jump behavior, so it still works even when the
  // link sits inside a Quick View modal (which the modal-dialog element
  // relocates to <body>, closing it here first) or under a sticky header.
  document.addEventListener('click', (event) => {
    const jumpLink = event.target.closest('.cgg-jump-link');
    if (!jumpLink) return;

    const href = jumpLink.getAttribute('href') || '';
    if (!href.startsWith('#') || href.length < 2) return;

    event.preventDefault();

    // Close the modal regardless of whether the target below resolves, so a
    // bad or missing anchor never leaves the panel stuck open.
    const modal = jumpLink.closest('.cgg-modal');
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }

    const target = document.getElementById(href.slice(1));
    if (!target) {
      console.warn('Corporate Gifting Guide: jump target "' + href + '" was not found on this page.');
      return;
    }

    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
